<template>
    <df-admin-list :title="title" :icon="icon" :total="rows.length">

        <table class="table table-hover no-footer">
            <thead>
            <tr>
                <th v-for="(col, k) in cols" :key="k">{{col}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!rows.length">
                <td class="text-center text-danger" :colspan="cols.length">Keine Datensätze vorhanden.</td>
            </tr>
            <component
                v-else
                :is="TableRow"
                :row="row"
                v-for="row in rows"
                :key="row.id"
                @reload="$emit('reload')"
                @update="(...v) => $emit('update', ...v)"
                @remove="v => removeRow = v"
            />
            </tbody>
        </table>

        <be-modal with-header with-footer effect="1" full-color="danger" :show="!!removeRow" v-if="removeModal && rows.length">
            <div class="text-center"><span class="modal-main-icon mdi mdi-alert-triangle"></span>
                <slot>
                    <h3>Löschen bestätigen</h3>
                    <p>{{removeModal.text}}<br>Dieser Vorgang kann nicht rückgängig gemacht werden!</p>
                </slot>
                <div class="mt-8">
                    <button class="btn btn-secondary btn-space" type="button" @click="confirmRemove">{{removeModal.button}}</button>
                    <button class="btn btn-success btn-space" type="button" @click="removeRow = null">Abbrechen</button>
                </div>
            </div>
        </be-modal>
    </df-admin-list>
</template>

<script>
    import errorHandler from '../../../mixins/errorHandler';

    export default {
        mixins: [errorHandler],

        props: {
            rows: Array,
            title: String,
            icon: String,
        },

        methods: {
            async confirmRemove() {
                try {
                    await this.removeRow.delete();
                } catch (err) {
                    this.catchError('Fehler beim Löschen', this.removeModal.error, err);
                } finally {
                    this.removeRow = null;
                    this.$emit('reload');
                }
            },
        },
    };
</script>
